// V1 unified tier system — credit economy retired, access is gated by subscription tier.
export const SUBSCRIBED_PLANS = ["plus", "pro", "gold"];

export function isSubscribed(user) {
  if (!user) return false;
  if (user.is_admin) return true;
  return SUBSCRIBED_PLANS.includes(user.plan);
}

const PLAN_LABELS = {
  free: "Free",
  plus: "Plus",
  pro: "Pro",
  gold: "Elite", // internal key kept as "gold" (Stripe/webhooks) — display renamed to ELITE
};

export function planLabel(user) {
  if (!user) return "Free";
  if (user.is_admin) return "Owner";
  return PLAN_LABELS[user.plan] || "Free";
}

// Monthly/yearly pricing shown in Settings, upsell modals, and the pricing table —
// single source of truth so every surface (ShopTab, PaywallInterceptor, DemoPaywall,
// Landing) stays in sync. Annual = 10x monthly (2 months free).
export const PLAN_META = {
  free: { label: "Free", monthly: 0, yearly: 0 },
  plus: { label: "Plus", monthly: 4.99, yearly: 49.90 },
  pro:  { label: "Pro", monthly: 9.99, yearly: 99.90, popular: true },
  gold: { label: "Elite", monthly: 19.99, yearly: 199.90 },
};

// 50-second interactive demo for unsubscribed users.
export const DEMO_DURATION_MS = 50 * 1000;
